import { createContext } from 'react'

import { ViewType } from '@/modules/shared/types/ViewType'

export const ViewTypeContext = createContext<ViewType | undefined>(undefined)
